export const iconFontAwesomeTimeCalendarPlus = (
	<i className="fa-solid fa-calendar-plus"></i>
);
